<script>
	import './index.scss';
	import { pkgBrief } from "../store.js";

	export let index;

	function removeElement(index) {
		$pkgBrief.splice(index, 1);
		$pkgBrief = $pkgBrief;
	}
</script>

<div class="field">
	<label class="label has-text-white">Title <a class="help remove-element" on:click={() => removeElement(index)}>(click to remove)</a></label>
	<div class="control">
		<input class="input has-text-white has-background-dark" type="text" placeholder="Text input" bind:value={$pkgBrief[index].content}>
	</div>
</div>